import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router";

function Navbar() {
  const [showTopbar, setShowTopbar] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopbar(window.scrollY < 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed-top">
      {/* Topbar with Contact & Liturgical Quick-Info */}
      {showTopbar && (
        <div className="topbar d-none d-lg-block">
          <div className="container d-flex justify-content-between align-items-center">
            <div className="top-info text-white d-flex align-items-center gap-4">
              <span>
                <i className="fas fa-map-marker-alt me-2 text-secondary"></i>
                E Veli St, Madurai, Tamil Nadu 625001
              </span>
              <span>
                <i className="fas fa-envelope me-2 text-secondary"></i>
                <a href="mailto:stmaryscathedral1841@gmail.com" className="text-white text-decoration-none">
                  stmaryscathedral1841@gmail.com
                </a>
              </span>
              <span>
                <i className="fas fa-phone-alt me-2 text-secondary"></i>
                <a href="tel:+919176155356" className="text-white text-decoration-none">
                  +91 91761 55356
                </a>
              </span>
            </div>
            <div className="top-link">
              <span className="badge rounded-pill me-3" style={{ background: "rgba(184, 149, 71, 0.25)", color: "#e8d5a8", border: "1px solid rgba(184, 149, 71, 0.4)", fontWeight: 500, fontSize: "0.78rem", padding: "5px 12px" }}>
                <i className="fas fa-bell me-1"></i> Daily Mass: 6:00 AM & 6:00 PM
              </span>
              <a href="https://youtube.com" className="text-white" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="https://instagram.com" className="text-white" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://twitter.com" className="text-white" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://facebook.com" className="text-white" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Main Navbar */}
      <div className="container px-3 px-lg-0">
        <nav className="navbar navbar-light bg-white navbar-expand-xl">
          <Link to="/" className="navbar-brand d-flex align-items-center gap-3" onClick={closeMobileMenu}>
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #1b3a6b, #102544)",
                border: "1.5px solid #b89547",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#f5eedb",
                fontSize: "1.2rem",
                boxShadow: "0 2px 8px rgba(27, 58, 107, 0.2)"
              }}
            >
              <i className="fas fa-cross"></i>
            </div>
            <div>
              <span className="brand-title">St. Mary's Cathedral</span>
              <span className="brand-sub">Madurai • Est. 1841</span>
            </div>
          </Link>

          {/* Mobile hamburger button */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-controls="navbarCathedral"
            aria-expanded={mobileMenuOpen}
            aria-label="Toggle navigation"
          >
            <i className={`fas ${mobileMenuOpen ? "fa-times" : "fa-bars"} text-primary`} style={{ fontSize: "1.2rem" }}></i>
          </button>

          {/* Navigation Links */}
          <div className={`collapse navbar-collapse ${mobileMenuOpen ? "show" : ""}`} id="navbarCathedral">
            <div className="navbar-nav mx-auto py-3 py-xl-0">
              <NavLink
                to="/"
                end
                className={({ isActive }) => `nav-item nav-link ${isActive ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                Home
              </NavLink>
              <NavLink
                to="/facts"
                className={({ isActive }) => `nav-item nav-link ${isActive ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                Facts
              </NavLink>
              <NavLink
                to="/history"
                className={({ isActive }) => `nav-item nav-link ${isActive ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                History
              </NavLink>
              <NavLink
                to="/substations"
                className={({ isActive }) => `nav-item nav-link ${isActive ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                Substations
              </NavLink>
              <NavLink
                to="/parish-admin"
                className={({ isActive }) => `nav-item nav-link ${isActive ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                Parish Admin
              </NavLink>
              <NavLink
                to="/photo-gallery"
                className={({ isActive }) => `nav-item nav-link ${isActive ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                Gallery
              </NavLink>
              <NavLink
                to="/contact"
                className={({ isActive }) => `nav-item nav-link ${isActive ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                Contact
              </NavLink>
            </div>

            {/* Quick Action Button */}
            <div className="d-flex align-items-center gap-2 mt-3 mt-xl-0">
              <Link
                to="/contact"
                className="btn-cathedral-gold"
                style={{ fontSize: "0.85rem", padding: "9px 20px" }}
                onClick={closeMobileMenu}
              >
                <i className="fas fa-church me-1"></i> Visit Parish
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
